import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore, serverTimestamp } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Firebase configuration - Using the same config from RallysApp
export const firebaseConfig = {
  apiKey: "AIzaSyC5Ccx-S6O4vYcRjxfYxr3rmIdpE78S0Uw",
  authDomain: "rallys-a017d.firebaseapp.com",
  projectId: "rallys-a017d",
  storageBucket: "rallys-a017d.firebasestorage.app",
  messagingSenderId: "1049802195863",
  appId: "1:1049802195863:web:29bedbdf3ffaee3d57fad2",
  measurementId: "G-ZT3FQXWJD6",
};

// Initialize Firebase
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const getNamedFirebaseApp = (name) => {
  const existingApp = getApps().find((firebaseApp) => firebaseApp.name === name);
  return existingApp || initializeApp(firebaseConfig, name);
};

// Initialize Firebase services
export const auth = getAuth(app);
let firestoreDb;
try {
  // Helps avoid websocket/watch instability in some local dev/network setups.
  firestoreDb = initializeFirestore(app, {
    experimentalAutoDetectLongPolling: true,
    useFetchStreams: false,
  });
} catch (error) {
  firestoreDb = getFirestore(app);
}

export const db = firestoreDb;
export const storage = getStorage(app);
export const cloudFunctions = getFunctions(app);
export { serverTimestamp };

export default app;
